import { render, staticRenderFns } from "./AdicionarPostagem.vue?vue&type=template&id=1a5026ea&"
import script from "./AdicionarPostagem.vue?vue&type=script&lang=js&"
export * from "./AdicionarPostagem.vue?vue&type=script&lang=js&"
import style0 from "./AdicionarPostagem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports